export const BASEURL = `http://localhost:3002/`;
export const AVATAR = `/avatar/`;
export const RELEASENOTES = `/releasenotes/`;
export const FAQ = `/faq/`;

//AUTH URLS
export const LOGIN = `/public/auth/login`;
export const LOGOUT = `/private/auth/logout`;
export const REGISTERORG = `/public/auth/register/organization`;
export const REGISTERFACULTY = `/public/auth/register/faculty`;
export const REGISTERPARENTS = `public/auth/register/parent`;
export const REGISTERSTUDENTBYPARENTS = `public/auth/register/student/byparent`;
export const REGISTEREXISTINGSTUDENTPARENTS = `public/auth/register/existingstudent/byparent`;
export const REGISTERSTUDENT = `/public/auth/register/student`;
export const REGISTERORGUSER = `/public/auth/register/organization/user`;
export const REGISTERSUBSCRIBER = `/public/auth/register/organization/subscriber`;
export const REGISTERORGUSERPRIVATE = `/private/auth/register/organization/user`;
export const REGISTERSUBSCRIBERPRIVATE = `/private/auth/register/organization/subscriber`;
export const REFRESHTOKEN = `/public/auth/refresh-token`;

//PASSWORD RESET URLS
export const FORGOTPASSWORD = `/public/auth/forgot-password`;
export const VERIFYFORGOTPASSWORDTOKEN = `/public/auth/verify-forgot-password`;
export const CHANGEPASSWORD = `/public/auth/change-password`;
export const RESETPASSWORD = `/private/auth/reset-password`;
export const TERMSANDCONDITION = `/private/auth/terms-and-condition`;

//USER URLS
export const UPDATEPROFILE = `/private/user/updateProfile`;
export const CREATETHRESHOLD = `/private/threshold`;
export const VERIFYTHRESHOLD = `private/threshold/alert/verify`;
export const MYTHRESHOLD = `/private/threshold/alert/history`;
export const DEACTIVATE = `/private/user/deactivateUserAccount`;
export const GETALERTBYID = `/public/threshold`;
export const UPLOADAVATAR = `/public/auth/upload/avatar`;
export const SUBMITFEEDBACK = `/private/supportcenter/submitfeedback`;
export const UPDATESCHOOL = `/private/auth/student/update-school`;
export const ALLORGUSERS = `/private/auth/organization/users`;

//ORGANIZATION URLS
export const GETORGLIST = `/public/organization/all`;
export const GETORGINFO = `/private/organization/info`;
export const UPDATEORGINFO = `/private/organization/info`;
export const ADDORGTHRESHOLD = `/private/organization/threshold`;
export const UPDATEORGTHRESHOLD = `/private/organization/threshold`;
export const GETORGTHRESHOLD = `/private/organization/threshold`;
export const ORGALERTHISTORY = `/private/organization/alert/history`;
export const ORGTODAYSCANS = '/private/organization/today/total-scans';
export const ORGFACULTYLIST = `/private/organization/faculty`;
export const ORGSTUDENTLIST = `/private/organization/student`;
export const ORGSUBSCRIBERLIST = `/private/organization/subscriber`;
export const ORGUSERLIST = `/private/organization/user`;
export const UPDATEORGPOC = `/private/organization/poc`;
export const GETALLQUESTION = `/private/questions/get/all`;
export const GETALLQUESTIONWOANS = `/private/questions/get/all/without/ans`;
export const QUESTION = `/private/questions`;

//FACULTY URLS
export const GETFACULTYINFO = `/private/faculty/myInfo`;
export const GETFACULTYORGPOC = `/private/faculty/organization/poc`;

//SUBSCRIBER URL
export const CREATESUBSCRIBERALERT = `/private/subscriber/alerts/create`;
export const GETSUBSCRIBERALERT = `/private/subscriber/alerts/list`;

//Check Email
export const CHECKEMAIL = `/public/auth/checkEmail`;

//PARENT URL
export const PARENTINFO = `/private/parent/myInfo`;
export const PARENTTOTALSCANS = `/private/parent/threshold/totalScans`;
export const PARENTALERTHSTORY = `/private/parent/threshold/alert/history`;
export const CREATEPARENTTHRESHOLD = `/private/parent/threshold`;
export const INVITEPARENT = `/public/auth/inviteParent`;
export const VERIFYINVITEPARENT = `/public/auth/verify-invite-parent`;
export const GETCARETAKER = `/private/parent/care-taker`;
export const GETCHILDREN = `/private/parent/children`;
export const TRANSFERROLE = `/private/parent/transfer-role`;
export const REMOVECHILDREN = `/private/parent/remove-child`;
export const ADDCHILDRENTOCARETAKER = `/private/parent/care-taker/add-child`;
export const ISACCOUNTPRIMARY = `/private/parent/is-account-primary`;
export const CARETAKERCHILD = `/private/parent/care-taker-child`;

//STUDENT URL
export const STUDENTALERTHISTORY = '/private/student/alert-history';
export const STUDENTTODAYSCAN = '/private/student/today-scans';
export const UPDATESTUDENTPROFILE = `/private/student/updateStudentProfile`;

//SUPER ADMIN URL
export const CHANGEVIEW = '/private/shp/change-view';
export const GETALLORG = '/private/shp/organization/list';
export const GETALLPARENT = '/private/shp/parent/list';
export const GETALLSTUDENTS = '/private/shp/student/list';
export const GETALLSUBSCRIBER = '/private/shp/subscriber/list';
export const GETALLFACULTIES = '/private/shp/faculty/list';
export const GETALLSUPERADMINUSER = '/private/shp/user/list';
export const GETFEEDBACKLIST = '/private/supportcenter/getAllFeedback';
export const GETUPDATETICKET = '/private/supportcenter/feedback';
export const GETRELEASELIST = '/private/supportcenter/getAllReleaseNote';
export const SUBMITRELEASENOTE = '/private/supportcenter/submitreleasenote';
export const GETALLFAQ = '/private/supportcenter/getAllFAQ';
export const SUBMITFAQ = '/private/supportcenter/submitFAQ';
export const GETGRAPHANALYSIS = '/private/shp/report-analysis/graph';
export const GETCOUNTANALYSIS = '/private/shp/report-analysis/count';
export const UPDATERELEASENOTE = '/private/supportcenter/updateReleaseNote';
export const UPDATEFAQ = '/private/supportcenter/updateFaq';
export const REGISTERADMIN = '/private/auth/register/shp/admin';
export const GETANALYTICS = '/private/shp/google-analytics';
export const GETENGAGEMENT = '/private/shp/engagements';
export const DEACTIVATEUSERACCOUNTBYSHP = '/private/shp/deactivateUserAccountBySHPAdmin';
export const ACTIVATEUSERACCOUNTBYSHP = '/private/shp/activateUserAccountBySHPAdmin';
export const REMOVEUSERACCOUNT = '/private/shp/removeUserAccount';
export const REMOVEUSERACCOUNTBYSHP = '/private/shp/removeUserAccountBySHPAdmin';
export const LIVEUSER = '/private/shp/live-users';
export const VIEWS3FILE = '/public/auth/s3file';
